export const documentCategories = [
    {
        name: "Customer",
        value: "CUSTOMER"
      },
      {
        name: "Natural Person",
        value: "NATURAL_PERSON"
      },
      {
        name: "Claim",
        value: "CLAIM"
      },
      {
        name: "Company",
        value: "COMPANY"
      },
      {
        name: "Vehicle",
        value: "VEHICLE"
      },
      {
        name: "Driver",
        value: "DRIVER"
      },
      {
        name: "Payment",
        value: "Payment"
      }
]